import { render, staticRenderFns } from "./PageTop.vue?vue&type=template&id=6c4da838&scoped=true&"
import script from "./PageTop.vue?vue&type=script&lang=js&"
export * from "./PageTop.vue?vue&type=script&lang=js&"
import style0 from "./PageTop.vue?vue&type=style&index=0&id=6c4da838&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4da838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c4da838')) {
      api.createRecord('6c4da838', component.options)
    } else {
      api.reload('6c4da838', component.options)
    }
    module.hot.accept("./PageTop.vue?vue&type=template&id=6c4da838&scoped=true&", function () {
      api.rerender('6c4da838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/PageTop.vue"
export default component.exports